import { userProfileConstants } from '../../_constants';

const initialState = { userProfileLoading: true, data: '', error: false };

export function getUserProfile(state = initialState, action) {
    
    switch (action.type) {
        case userProfileConstants.REQUEST_USER_PROFILE:
            return {
                userProfileLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_USER_PROFILE:
            return {
                userProfileLoading: false,
                data: action.getUserProfile,
                error: false
            };
        case userProfileConstants.USER_PROFILE_ERROR:
            return {
                userProfileLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/getUserProfile.reducer.js